<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/1/image00004.jpeg"
        class="card-img-top"
        :alt="$t('voyagesResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("voyagesResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("voyagesResume.text.p1") }}
      </p>

      <a
        href="/voyages-et-residences-secondaires"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("voyagesResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoyagesResume",
};
</script>

<style></style>
